/* ===========================================
   BC Announcement Bar
   Berserker Coffee Co.
   =========================================== */

(function () {
  'use strict';

  function initPromoBanner(bar) {
    if (!bar) return;

    var promoKey  = bar.dataset.promoKey;
    var closable  = bar.dataset.closable === 'true';
    var closeBtn  = bar.querySelector('[data-promo-close]');

    // Already dismissed this session? (skip in Theme Editor)
    var inEditor = window.Shopify && window.Shopify.designMode;
    if (!inEditor && promoKey && sessionStorage.getItem(promoKey) === 'closed') {
      bar.classList.add('bc-announcement-bar--closed');
      return;
    }
    bar.classList.remove('bc-announcement-bar--closed');

    if (!closeBtn || !closable) return;

    closeBtn.addEventListener('click', function () {
      bar.classList.add('bc-announcement-bar--closed');

      // Persist for current session
      if (promoKey) {
        try {
          sessionStorage.setItem(promoKey, 'closed');
        } catch (e) {
          // sessionStorage blocked (private mode etc.) – silently ignore
        }
      }
    });
  }

  function initMarquee(bar) {
    if (!bar) return;
    var track = bar.querySelector('.bc-announcement-bar__track');
    if (!track) return;

    var sets = track.querySelectorAll('.bc-announcement-bar__track-set');
    if (!sets.length) return;

    // Measure a single set (first one)
    var setWidth = sets[0].offsetWidth;
    if (!setWidth) return;

    // Need total track to be at least 2× viewport so the loop never shows a gap
    var target = window.innerWidth * 2;
    var currentTotal = setWidth * sets.length;

    while (currentTotal < target) {
      var clone = sets[0].cloneNode(true);
      track.appendChild(clone);
      currentTotal += setWidth;
    }

    // Update the animation end-value: shift exactly 1 set = 1/N of total
    var totalSets = track.querySelectorAll('.bc-announcement-bar__track-set').length;
    track.style.setProperty('--bc-marquee-end', '-' + (100 / totalSets).toFixed(4) + '%');
  }

  function init() {
    document.querySelectorAll('.bc-announcement-bar--promo').forEach(initPromoBanner);
    document.querySelectorAll('.bc-announcement-bar--marquee').forEach(initMarquee);
  }

  // Theme Editor: re-init when section reloads
  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector('.bc-announcement-bar--promo');
    if (bar) initPromoBanner(bar);
    var marquee = e.target.querySelector('.bc-announcement-bar--marquee');
    if (marquee) initMarquee(marquee);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
